export default "__VITE_ASSET__aa0bf430__"